import React from 'react';
import "../styles/Services.css"
import {BiCodeAlt, BiCodeBlock, BiData} from "react-icons/bi"
import { motion } from "framer-motion";

const Services = () => {

   const fade = {
    opacity: 1,
    transition:{
        duration: 1.4
    }
   }

  return (
      <>
          <div className="services" id='services'>
              <div className="container">
                <motion.div whileInView={fade} viewport={{ once: true }} initial={{opacity: 0}} className="heading">
                    <p className="heading-sub-text">What I can do</p>
                    <p className='heading-text'>Services</p>
                </motion.div>
                <motion.div className="services-box" whileInView={fade} initial={{opacity: 0}}>
                    <div className="services-card">
                        <BiCodeAlt className='services-icon' />
                        <p className='services-title'>Backend Development</p>
                        <p className='services-desc'>I collaborate closely with you using agile methodologies and employ suitable programming languages to develop fast, optimal, and scalable custom software solutions.</p>
                    </div>
                    <div className="services-card">
                        <BiCodeBlock className='services-icon' />
                        <p className='services-title'>Web Application Development</p>
                        <p className='services-desc'>As a proficient software engineer, I leverage cutting-edge web technologies to expertly develop captivating web applications in accordance with provided designs and requirements.</p>
                    </div>
                    <div className="services-card">
                        <BiData className='services-icon' />
                        <p className='services-title'>Database Architecture</p>
                        <p className='services-desc'>I design and implement efficient, scalable database structures to boost systems performance, reliability, and user experience.</p>
                    </div>
                </motion.div>
              </div>
          </div>
      </>
  )
};

export default Services;
